export function update(uid){
	// console.log(timeinterval);
	// console.log(typeof(timeinterval));
	var timer;
	(function _update() {
		$.ajax({
			url: "../php/update.php",
			method: "post",
			data:"user="+uid,
			timeout:100000,
			cache: false,
			success: function(r1,r2,r3){
				//console.log(r1);
				$("#history").bootstrapTable('refresh', {
					// url: 'http://rpa.renlab.org/json/model/'+uid+'.json',
					url: '/json/model/'+uid+'.json',
					silent: true,
					query: {
						ts: (new Date()).getTime(),
					},
				});
				if(r1==="finished"){
					// console.log(r1);
					// clear global timer
					clearInterval(timer);
				} else{
					// console.log(r1);
					if (!timer) {
						// set global timer
						timer = setInterval(function () {
							_update();
						},3000);
					}
				}
			},
			error: function(r1){
				console.error(r1);
			}
		});
	})();
}

export function update2(uid){
	var timer;
	(function _update() {
		$.ajax({
			url: "../php/update2.php",
			method: "post",
			data:"user="+uid,
			timeout:100000,
			success: function(r1,r2,r3){
				// console.log(r1);
				// add timestamp to disable cache
				$("#history").bootstrapTable('refresh', {
					// url: 'http://rpa.renlab.org/json/compare/'+uid+'.json',
					url: '/json/compare/'+uid+'.json',
					silent: true,
					query: {
						ts: (new Date()).getTime(),
					},
				});
				if(r1==="finished"){
					// console.log(r1);
					// clear global timer
					clearInterval(timer);
				}
				else{
					// console.log(r1);
					if (!timer) {
						// set global timer
						timer = setInterval(function () {
							_update();
						},3000);
					}
				}
			},
			error: function(r1){
				console.error(r1);
			}
		});
	})();
}